var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component, createRef } from 'react';
import { PhotoSource } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { bool, eventListener, instanceOf, oneOf, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { ChangeEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { classNames, enumValues, isFunction } from '@philips-internal/oswald-ui-utils';
import { Button } from '../button/button.js';
import { Image } from '../image/image.js';
import PhotoUploaderAPI from './photo-uploader-api.js';
import './photo-uploader.css';
let PhotoUploader = class PhotoUploader extends Component {
    constructor() {
        super(...arguments);
        this.state = {};
        this.fileReader = new FileReader();
        this.inputRef = createRef();
        this.onPhotoChange = (event) => {
            const { onChange, value: oldValue } = this.props;
            if (isFunction(onChange)) {
                onChange(new ChangeEvent({ oldValue, value: event.target.files?.[0] }));
            }
        };
        this.onTakePhotoClick = () => {
            this.inputRef.current?.click();
        };
    }
    componentDidMount() {
        const { value } = this.props;
        this.fileReader.onload = (event) => {
            const src = event.target ? event.target.result : undefined;
            this.setState({ photoSrc: src });
        };
        if (value) {
            this.fileReader.readAsDataURL(value);
        }
    }
    componentDidUpdate(prevProps) {
        const { value } = this.props;
        if (value !== prevProps.value) {
            this.fileReader.readAsDataURL(value);
        }
    }
    componentWillUnmount() {
        this.fileReader.abort();
    }
    getClassName() {
        const { className } = this.props;
        return classNames({
            'c-photo-uploader': true,
            [`${className}`]: Boolean(className),
        });
    }
    renderButton() {
        const { enabled, readOnly, takePhotoExpression } = this.props;
        if (readOnly) {
            return null;
        }
        return (React.createElement(Button, { className: "c-photo-uploader__button", enabled: enabled, onClick: this.onTakePhotoClick, value: takePhotoExpression }));
    }
    renderInput() {
        const { readOnly, source } = this.props;
        if (readOnly) {
            return null;
        }
        const extraFileProperties = {};
        if (source !== PhotoSource.ALL) {
            extraFileProperties.capture = source;
        }
        return (React.createElement("input", { accept: "image/*", className: "c-photo-uploader__file", onChange: this.onPhotoChange, ref: this.inputRef, type: "file", ...extraFileProperties }));
    }
    renderPhoto() {
        const { photoVisible } = this.props;
        const { photoSrc } = this.state;
        if (!photoVisible || !photoSrc) {
            return null;
        }
        return (React.createElement(Image, { alt: "tws.photo-uploader.selected-photo", className: "c-photo-uploader__preview", maxWidth: "20rem", src: photoSrc }));
    }
    render() {
        return (React.createElement("div", { className: this.getClassName() },
            this.renderButton(),
            this.renderInput(),
            this.renderPhoto()));
    }
};
PhotoUploader.propTypes = {
    className: string,
    enabled: bool,
    onChange: eventListener,
    photoVisible: bool,
    readOnly: bool,
    source: oneOf(enumValues(PhotoSource)),
    takePhotoExpression: string,
    value: instanceOf(Blob),
};
PhotoUploader.defaultProps = {
    enabled: true,
    photoVisible: true,
    source: PhotoSource.ALL,
    takePhotoExpression: 'tws.photo-uploader.take-photo',
};
PhotoUploader = __decorate([
    AwesomeComponent({ api: PhotoUploaderAPI, type: ComponentType.DATA_ENTRY })
], PhotoUploader);
export default PhotoUploader;
//# sourceMappingURL=photo-uploader.js.map